// import React from 'react';
// import styled from 'styled-components';
// import { useSpring, animated } from 'react-spring';
// import backgroundImage from '../assets/6a0f3738606f195c4f3d5886cdb825f5.png';
// import logo from '../assets/eba836181a8bb389cc40f37585eec6ae.png';

// const DownloadAppComponent = () => {
//   const fadeIn = useSpring({
//     from: { opacity: 0 },
//     to: { opacity: 1 },
//   });

//   return (
//     <Container>
//       <Content style={fadeIn}>
//         <Logo src={logo} alt="Mazadate Masr" />
//         <Title>Mazadate Masr</Title>
//         <Description>
//           Experience the best auctions and bidding experience with Mazadate Masr. Download our app now and join the exciting world of auctions!
//         </Description>
//         <DownloadButton>Download the App</DownloadButton>
//       </Content>
//     </Container>
//   );
// };

// const Container = styled.div`
//   background-image: url(${backgroundImage});
//   background-size: cover;
//   background-position: center;
//   width: 100%;
//   height: 100vh;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// const Content = styled(animated.div)`
//   background-color: rgba(255, 255, 255, 0.8);
//   padding: 2rem;
//   border-radius: 8px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
//   text-align: center;
//   max-width: 400px;
// `;

// const Logo = styled.img`
//   width: 150px;
//   margin-bottom: 1rem;
// `;

// const Title = styled.h1`
//   font-size: 2rem;
//   color: black;
//   font-weight: bold;
//   margin-bottom: 1rem;
// `;

// const Description = styled.p`
//   font-size: 1rem;
//   color: gray;
//   margin-bottom: 1.5rem;
// `;

// const DownloadButton = styled.button`
//   background-color: red;
//   color: white;
//   padding: 1rem 2rem;
//   font-size: 1rem;
//   border: none;
//   border-radius: 4px;
//   cursor: pointer;
//   &:hover {
//     background-color: darkred;
//   }
// `;

// export default DownloadAppComponent;






import React from 'react';
import { Box, Button, Image, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import backgroundImage from '../assets/6a0f3738606f195c4f3d5886cdb825f5.png';
import logo from '../assets/eba836181a8bb389cc40f37585eec6ae.png';

const MotionBox = motion(Box);

const DownloadAppComponent = () => {
  return (
    <MotionBox
      backgroundImage={`url(${backgroundImage})`}
      backgroundSize="cover"
      backgroundPosition="center"
      width="100%"
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <VStack
        spacing={6}
        p={8}
        backgroundColor="rgba(255, 255, 255, 0.8)"
        borderRadius="md"
        boxShadow="lg"
        maxW="90%" // This will ensure it is responsive
        textAlign="center" // Center text alignment
      >
        <Image src={logo} alt="Mazadate Masr" width={{ base: '100px', md: '150px' }} />
        <Text fontSize={{ base: 'xl', md: '2xl' }} color="black" fontWeight="bold">
          Mazadate Masr
        </Text>
        <Text fontSize={{ base: 'md', md: 'lg' }} color="gray.700">
          Experience the best auctions and bidding experience with Mazadate Masr. Download our app now and join the exciting world of auctions!
        </Text>
        <Button
          colorScheme="red"
          size="lg"
          as={motion.button}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          Download the App
        </Button>
      </VStack>
    </MotionBox>
  );
};

export default DownloadAppComponent;
